import { useEffect, useState } from 'react';
import axios from 'axios';
import '../thankyou/styles.scss';
import 'react-loading-skeleton/dist/skeleton.css'
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";


import { Fade } from "react-awesome-reveal";
import PageLoader from '../../components/global/loader/PageLoader';
import { InternalBanner } from "../../components/internals/InternalBanner";

const Thankyou = () => {
    const [isFetchingPageData, setIsFetchingPageData] = useState(true);
    const [pageContent, setPageContent] = useState(null);

    useEffect(() => {
        fetchPageContent();
    }, []);

    const fetchPageContent = async () => {
        setIsFetchingPageData(true);
        try {
            const { data } = await axios.get(`/wp-admin/admin-ajax.php?action=get_pages_by_page_name&page_name=thank_you`);
            setPageContent(data);
            if (data?.yoast_title?.length > 0) {
                const finalTitle = data.yoast_title
                    .replace("%%title%%", data?.page?.post_title ? data?.page?.post_title : '')
                    .replace("%%page%%", "")
                    .replace("%%sep%%", "-")
                    .replace("%%sitename%%", "Alinea Law PLLC")

                document.title = finalTitle;
            } else {
                document.title = data?.page?.post_title ? `${data?.page?.post_title} - Alinea Law PLLC` : "Thank you - Alinea Law PLLC";
            }
            if (document.querySelector('#wp-admin-bar-edit a')) {
                document.querySelector('#wp-admin-bar-edit a').innerText = `Edit Page`;
                document.querySelector('#wp-admin-bar-edit a').href = `/wp-admin/post.php?post=${data?.page?.ID}&action=edit`;
            }
        } catch (err) {
            console.log(err);
        } finally {
            setIsFetchingPageData(false);
        }
    }


    useEffect(() => {
        if (isFetchingPageData) {
            document.body.classList.add('is-page-loading');
        } else {
            document.body.classList.remove('is-page-loading');
        }
    }, [isFetchingPageData]);



    return <Fade delay={1}>
        <main id="main" className="resources">
            {!isFetchingPageData && <>
                <InternalBanner page={pageContent?.page} />
                <section id="resources-section" className="internal-section">
                    <div className="container">
                        <article dangerouslySetInnerHTML={{__html: pageContent?.page_content}}>    
                        </article>
                    </div>
                </section>
            </>}

            {isFetchingPageData && <>
                <PageLoader />
            </>}
        </main>
    </Fade>
}

export default Thankyou;